import React from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { AuthForm } from "../components/auth/AuthForm";
import { useAuth } from "../contexts/AuthContext";
import { clinic } from "../data/clinic";
export function Login() {
  const {
    user
  } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const from = (location.state as {
    from?: string;
  } | null)?.from ?? "/mon-espace";
  if (user) return <Navigate to={from} replace data-id="element-409" data-mp="33etso8whn8q6" />;
  return <div className="bg-surface" data-id="element-410" data-mp="38dobhauggxaa">
      <div className="mx-auto grid max-w-6xl gap-10 px-5 py-12 md:px-8 md:py-20 lg:grid-cols-2 lg:gap-16" data-id="element-411" data-mp="38btrpzux7b7s">
        <div className="flex flex-col justify-between rounded-3xl bg-brand p-8 text-white md:p-12" data-id="element-412" data-mp="2tnpe3aaq5pvv">
          <div data-id="element-413" data-mp="2ylqutokohd46">
            <h1 className="text-3xl font-semibold tracking-tight md:text-4xl" data-id="element-414" data-mp="2yl8ry93ig0na">Votre espace patient</h1>
            <p className="mt-4 max-w-md text-base leading-relaxed text-white/80" data-id="element-415" data-mp="3mb34epjx3n70">
              Réservez en quelques clics, retrouvez vos prochains rendez-vous et annulez-les sans appeler le
              cabinet, jusqu'à 24 h avant.
            </p>
          </div>
          <div className="mt-12 border-t border-white/15 pt-6 text-sm text-white/80" data-id="element-416" data-mp="2mjae20vb2n0w">
            <p data-id="element-417" data-mp="317x52zuap37y">Une question ? Le cabinet reste joignable par téléphone.</p>
            <a href={clinic.phoneHref} className="mt-1 inline-block text-lg font-semibold text-white hover:underline" data-id="element-418" data-mp="2wflvf59r6327">
              {clinic.phone}
            </a>
          </div>
        </div>

        <div className="rounded-3xl border border-line bg-white p-6 md:p-10" data-id="element-419" data-mp="358pf3vazrc5a">
          <AuthForm onSuccess={() => navigate(from, {
          replace: true
        })} data-id="element-420" data-mp="35atgo6lf3z2e" />
        </div>
      </div>
    </div>;
}